import { useQuery, useQueryClient } from '@tanstack/react-query'
import { useCallback } from 'react'
import { profileService } from '../../../services/profile'

export const OTHER_PROFILE_QUERY_KEY = 'getOtherProfile'

export const useGetOtherProfile = (userId?: number) => {
  const queryClient = useQueryClient()

  const { data, isLoading, refetch } = useQuery({
    queryKey: [OTHER_PROFILE_QUERY_KEY, userId && { id: Number(userId) }],
    enabled: !!userId,
    staleTime: 0,
    queryFn: () => profileService.getOther({ id: Number(userId) }),
  })

  const handleSearchProfile = useCallback(
    async (id: number, cached = false) => {
      const response = await queryClient.fetchQuery({
        queryKey: [OTHER_PROFILE_QUERY_KEY, { id }],
        staleTime: cached ? Infinity : 0,
        queryFn: () => profileService.getOther({ id }),
      })

      return response?.data
    },
    [queryClient],
  )

  return {
    user: data?.data,
    isLoading,
    refetch,
    handleSearchProfile,
  }
}
